export const AppVersion = '0.5.4';

export const DataVersion = '06/21';